<div class="container">
  <div class="head_r my-3">
    <div class="row">
      <div class="col-md-4">
        <mat-form-field class="szs">
          <mat-label>Choose Client</mat-label>
          <mat-select [(ngModel)]="clientttt" (selectionChange)="changeSate()">
            <mat-option [value]="c.clientID" *ngFor="let c of clients">
              {{c.name}}
            </mat-option>

          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field class="szs">
          <mat-label>Choose a date</mat-label>
          <input matInput (dateInput)="changeSate()" [(ngModel)]="dates" [matDatepicker]="pickesr">
          <mat-datepicker-toggle matSuffix [for]="pickesr"></mat-datepicker-toggle>
          <mat-datepicker #pickesr></mat-datepicker>
        </mat-form-field>
        <div class="btn_hold_date" *ngIf="dates">
          <button mat-raised-button color="accent" (click)="resetFiltersOld()">Reset Filter</button>
        </div>
      </div>

      <div class="col-md-4" *ngIf="false">
        <mat-form-field class="szs">
          <mat-label>Choose a date</mat-label>
          <input matInput (dateInput)="changeSate()" [(ngModel)]="datee" [matDatepicker]="picker">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <div class="btn_hold_date" *ngIf="clientttt">
          <button mat-raised-button color="accent" (click)="get_progressLogs()">Search Logs</button>
          <button mat-raised-button color="accent" (click)="resetFilters()">Reset Filter</button>
        </div>
      </div>
    </div>




  </div>
  <mat-table [dataSource]="dataSource" class="mat-elevation-z8">
    <ng-container matColumnDef="p_id">
      <mat-header-cell *matHeaderCellDef> Process Id </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.id}} </mat-cell>
    </ng-container>

    <!-- Name Column -->
    <!--<ng-container matColumnDef="ptype">
      <mat-header-cell *matHeaderCellDef> Process Type </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.type}} </mat-cell>
    </ng-container>-->
    <!-- Weight Column -->
    <ng-container matColumnDef="sdate">
      <mat-header-cell *matHeaderCellDef> Process Start Date </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{uis.dateFormatter(element.startTime)}}-{{uis.formatAMPMT(element.startTime)}} </mat-cell>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="edate">
      <mat-header-cell *matHeaderCellDef> Process End Date </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{uis.dateFormatter(element.endTime)}}-{{uis.formatAMPMT(element.endTime)}} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="status">
      <mat-header-cell *matHeaderCellDef> Process Status </mat-header-cell>
      <mat-cell *matCellDef="let element"> {{element.status}} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="dload">
      <mat-header-cell *matHeaderCellDef> Missing Fields </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <button [ngStyle]="{'color': element.missingFieldCount>0?'black':'grey'}" mat-icon-button (click)="getMissField(element.id,element.clientId,element.missingFieldCount)">
          <mat-icon>cloud_download</mat-icon>
        </button>

      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="loading">
      <mat-footer-cell *matFooterCellDef colspan="4">
        {{
getStatus()=='load'?'Loading Missing Fields':'No Missing Fields Found'
        }}
      </mat-footer-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    <mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'hide' :!getStatus() }"></mat-footer-row>

  </mat-table>
  <mat-paginator [length]="100"
                 [pageSize]="10"
                 [pageSizeOptions]="[5, 10, 25, 100]">
  </mat-paginator>
</div>
